import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { currentProject } from 'app/store/project/current-project/current-project.selectors';
import { ownedError } from 'core/utils/owned-error';
import { selectFirst } from 'core/utils/rx-common';
import { Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class ProjectInterceptor implements HttpInterceptor {
  constructor(private store$: Store) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.store$
      .pipe(
        selectFirst(currentProject),
        map((p) => {
          if (!p || Object.keys(p).length === 0) {
            throw ownedError(new Error('Current project is missing'));
          }

          return request.clone({
            setHeaders: {
              'Project-Id': p.id,
            },
          });
        }),
        switchMap((r) => {
          return next.handle(r);
        }),
      );
  }
}
